<template>
  <transition name="fade">
    <div
      class="my-overlay"
    >
      <v-layout
        align-center
        justify-center
        fill-height
        column
        light
      >
        <span class="headline font-weight-light white--text">{{ text }}</span>
        <v-progress-circular
          :size="70"
          :width="7"
          indeterminate
          color="white"
        ></v-progress-circular>
      </v-layout>
    </div>
  </transition>
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  components: {
  },
  computed: {
  },
};
</script>

<style scoped>
.my-overlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 30;
  background-color: rgba(0, 0, 0, 1);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
